import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { SegmentedPill } from './SegmentedPill';

interface SegmentedToggleProps {
  name: string;
  options: { label: string; value: string }[];
  readonly?: boolean;
}

/**
 * Segmented toggle control - refined pill-style toggle.
 * For binary choices like Free/Gated.
 */
const SegmentedToggle: React.FC<SegmentedToggleProps> = ({ name, options, readonly = false }) => {
  const { setValue, control } = useFormContext();
  const currentValue = useWatch({ control, name });

  const handlePress = (value: string) => {
    if (readonly) return;
    setValue(name, value, { shouldDirty: true });
  };

  return (
    <SegmentedPill
      options={options}
      value={currentValue}
      onChange={handlePress}
      disabled={readonly}
    />
  );
};

export default SegmentedToggle;
